var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7777 6.60156H1.89502C1.61902 6.60156 1.39502 6.37756 1.39502 6.10156C1.39502 5.82556 1.61902 5.60156 1.89502 5.60156H13.7777C14.0537 5.60156 14.2777 5.82556 14.2777 6.10156C14.2777 6.37756 14.0537 6.60156 13.7777 6.60156Z",
    fill: "#666E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.801 9.20312C10.525 9.20312 10.2983 8.97913 10.2983 8.70312C10.2983 8.42713 10.519 8.20312 10.795 8.20312H10.801C11.077 8.20312 11.301 8.42713 11.301 8.70312C11.301 8.97913 11.077 9.20312 10.801 9.20312Z",
    fill: "#666E7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84251 9.20312C7.56651 9.20312 7.33984 8.97913 7.33984 8.70312C7.33984 8.42713 7.56051 8.20312 7.83651 8.20312H7.84251C8.11851 8.20312 8.34251 8.42713 8.34251 8.70312C8.34251 8.97913 8.11851 9.20312 7.84251 9.20312Z",
    fill: "#666E7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87833 9.20312C4.60233 9.20312 4.375 8.97913 4.375 8.70312C4.375 8.42713 4.59633 8.20312 4.87233 8.20312H4.87833C5.15433 8.20312 5.37833 8.42713 5.37833 8.70312C5.37833 8.97913 5.15433 9.20312 4.87833 9.20312Z",
    fill: "#666E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.801 11.7969C10.525 11.7969 10.2983 11.5729 10.2983 11.2969C10.2983 11.0209 10.519 10.7969 10.795 10.7969H10.801C11.077 10.7969 11.301 11.0209 11.301 11.2969C11.301 11.5729 11.077 11.7969 10.801 11.7969Z",
    fill: "#666E7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84251 11.7969C7.56651 11.7969 7.33984 11.5729 7.33984 11.2969C7.33984 11.0209 7.56051 10.7969 7.83651 10.7969H7.84251C8.11851 10.7969 8.34251 11.0209 8.34251 11.2969C8.34251 11.5729 8.11851 11.7969 7.84251 11.7969Z",
    fill: "#666E7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87833 11.7969C4.60233 11.7969 4.375 11.5729 4.375 11.2969C4.375 11.0209 4.59633 10.7969 4.87233 10.7969H4.87833C5.15433 10.7969 5.37833 11.0209 5.37833 11.2969C5.37833 11.5729 5.15433 11.7969 4.87833 11.7969Z",
    fill: "#666E7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5293 3.85806C10.2533 3.85806 10.0293 3.63406 10.0293 3.35806V1.16406C10.0293 0.888062 10.2533 0.664062 10.5293 0.664062C10.8053 0.664062 11.0293 0.888062 11.0293 1.16406V3.35806C11.0293 3.63406 10.8053 3.85806 10.5293 3.85806Z",
    fill: "#666E7D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14355 3.85806C4.86755 3.85806 4.64355 3.63406 4.64355 3.35806V1.16406C4.64355 0.888062 4.86755 0.664062 5.14355 0.664062C5.41955 0.664062 5.64355 0.888062 5.64355 1.16406V3.35806C5.64355 3.63406 5.41955 3.85806 5.14355 3.85806Z",
    fill: "#666E7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11132_143304",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 1.71875H14.3335V14.9993H1.3335V1.71875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11132_143304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01416 2.71875C3.2855 2.71875 2.3335 3.64075 2.3335 5.31475V11.3474C2.3335 13.0581 3.2855 13.9994 5.01416 13.9994H10.6528C12.3815 13.9994 13.3335 13.0754 13.3335 11.3981V5.31475C13.3362 4.49142 13.1148 3.85142 12.6755 3.41142C12.2235 2.95808 11.5268 2.71875 10.6588 2.71875H5.01416ZM10.6528 14.9994H5.01416C2.74416 14.9994 1.3335 13.6001 1.3335 11.3474V5.31475C1.3335 3.09608 2.74416 1.71875 5.01416 1.71875H10.6588C11.7982 1.71875 12.7402 2.06008 13.3835 2.70475C14.0082 3.33208 14.3368 4.23408 14.3335 5.31608V11.3981C14.3335 13.6194 12.9228 14.9994 10.6528 14.9994Z",
    fill: "#666E7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.75d17b5a3b3a638ed1f5f1d628ec01a5.svg";
export { ForwardRef as ReactComponent };